import { render, staticRenderFns } from "./TeachSponsorPostulations.vue?vue&type=template&id=153d8192&"
import script from "./TeachSponsorPostulations.vue?vue&type=script&lang=js&"
export * from "./TeachSponsorPostulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports